// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
/** @jsx jsxPragma */

import { jsxPragma } from "@outschool/ui-legacy-component-library";
import { CardExpiryElement } from "@stripe/react-stripe-js";
import { CardExpiryElementProps } from "@stripe/react-stripe-js/src/types";
import { SystemStyleObject } from "@styled-system/css";
import _ from "lodash";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";

import { CARD_ELEMENT_OPTIONS, VARIANT_DEFAULT_SX, Variants } from ".";

interface StripeCardExpiryProps extends CardExpiryElementProps {
  variant?: Variants;
  sx?: SystemStyleObject;
}

export default function StripeCardExpiry({
  variant = Variants.valid,
  sx = {},
  options,
  ...props
}: StripeCardExpiryProps) {
  return (
    <CardExpiryElement
      options={_.merge(CARD_ELEMENT_OPTIONS, options)}
      // @ts-ignore
      sx={_.merge(VARIANT_DEFAULT_SX[variant], sx)}
      {...props}
    />
  );
}
